import React, { useState } from 'react';

import * as Yup from 'yup';

import ImageInput from '../Form/ImageInput';
import Input from '../Form/Input';
import Textarea from '../Form/Textarea';
import ModalForm from '../Modal/ModalForm';

export default function Modal(props) {
  const [previewUrl, setPreviewUrl] = useState(null);

  const schemaValidation = Yup.object().shape({
    // thumbnail: Yup.mixed().required('Selecione uma imagem'),
    title: Yup.string().required('O título é obrigatório'),
    // description: Yup.string().required('A descrição é obrigatória'),
    content: Yup.string().required('O conteúdo do post é obrigatório'),
  });

  const handleFormData = (data) => {
    const formData = new FormData();
    formData.append('thumbnail', data.thumbnail);
    formData.append('title', data.title);
    formData.append('description', data.description);
    formData.append('content', data.content);

    return formData;
  };

  return (
    <ModalForm
      title="Post"
      path="/posts"
      schemaValidation={schemaValidation}
      onPreview={setPreviewUrl}
      onFormData={handleFormData}
      {...props}
    >
      <ImageInput
        name="thumbnail"
        previewUrl={previewUrl}
      />
      <Input
        name="title"
        placeholder="Título"
      />
      <Input
        name="description"
        placeholder="Descrição"
      />
      <Textarea
        name="content"
        placeholder="Conteúdo do Post"
        rows={4}
      />
    </ModalForm>
  );
}
